import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { PromotionModel } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import CartLineQuantity, { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    wishListBadges: any[];
    productId: string;
    condensed?: boolean;
    // extendedStyles?: BadgeStyles;
}

type Props = OwnProps;

export interface BadgeStyles {
    container?: GridContainerProps;
    badgeLineInfoGridItem?: GridItemProps;
    bargeLineText?: TypographyProps;
}

export const badgeStyles: BadgeStyles = {
    container: {
        css: css`
            align-content: flex-end;
        `,
        offsetCss: css`
            display: flex;
            margin-left: inherit;
            flex-wrap: wrap;
            margin-bottom: 5px;
            gap: 16px;

            @media (max-width: 768px) {
                gap: 8px;
                margin: 10px 0;
            }
        `,
    },
};

export const getBadgeStyles = (listColor: string): BadgeStyles => ({
    badgeLineInfoGridItem: {
        css: css`
            font-size: 16px;
            padding: 5px 8px;
            color: #fff;
            border-radius: 5px;
            background-color: ${listColor};
            max-width: fit-content;
            flex-basis: fit-content;
        `,
    },
});

const BadgeComponent = ({ wishListBadges, productId, condensed }: Props) => {
    if (!wishListBadges || wishListBadges.length === 0) {
        return null;
    }

    const containerStyles = badgeStyles.container;
    if (containerStyles) {
        containerStyles.offsetCss = css`
            ${containerStyles.offsetCss}
            ${condensed
                ? css`
                      margin-left: 0;
                      margin-top: 0;
                      
                      @media (max-width: 768px) {
                          margin-left: 0;
                      }
                  `
                : css`
                      margin-left: 15px;
                      margin-top: 15px;

                      @media (max-width: 768px) {
                          margin-left: 15px;
                      }
                  `}
        `;
        badgeStyles.container = containerStyles;
    }

    const styles = badgeStyles;

    return (
        <GridContainer {...styles.container} data-test-selector={`badgets_${productId}`}>
            {wishListBadges.map(badge => {
                const stylesBadge = getBadgeStyles(badge.color);
                return (
                    <GridItem
                        {...stylesBadge.badgeLineInfoGridItem}
                        data-test-selector={`badget_line_${productId}_${badge.id}`}
                        key={`badget_line_${productId}_${badge.id}`}
                    >
                        <Typography>{badge.name}</Typography>
                    </GridItem>
                );
            })}
        </GridContainer>
    );
};

export default BadgeComponent;
